import { useTheme } from '@mui/material';

import { TypeCustomTexts, useCustomText } from '../../../contexts/InstitutionCustomTextContext';
import palette from '../../../theme/learnerPalette';
import AtomProgress from '../../atoms/AtomProgress';
import AtomTypography from '../../atoms/AtomTypography/AtomTypography';
import { styleConfigs } from '../../resources/styleConfigs';

const FooterComponent: React.FC = () => {
  const { loading, description } = useCustomText(TypeCustomTexts.FOOTER);
  const theme = useTheme();

  if (!description) {
    return null;
  }

  return (
    <AtomTypography
      component="div"
      sx={{
        fontWeight: styleConfigs.fonts.bold,
        width: styleConfigs.dimensions.percent100,
        marginTop: styleConfigs.marginPadding.custom20,
        borderTop: `${styleConfigs.borders.borderLine} ${palette.light.borders.cadetGrey}`,
        borderWidth: `${styleConfigs.borders.border3px}`,
        padding: theme.spacing(8, 0, 0, 0),
        fontSize: styleConfigs.fonts.fontSize16,
        textAlign: 'center',
        div: {
          maxWidth: styleConfigs.dimensions.width700,
          margin: `${styleConfigs.marginPadding.auto}`,
        },
      }}
    >
      {loading ? (
        <AtomProgress
          visible
          layout="inline"
          background="transparent"
          textColor="prussianBlue"
          data-testid="circular_loader"
        />
      ) : (
        <footer role="contentinfo">
          <div>{description}</div>
        </footer>
      )}
    </AtomTypography>
  );
};

export default FooterComponent;
